__turbopack_context__.v({
  "containerBase": "Container-module-scss-module__B3GkNW__containerBase",
  "fullWidthGutter": "Container-module-scss-module__B3GkNW__fullWidthGutter",
});
